import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { NotesTemplateEvent } from './notes_templates_events';

@Injectable({ providedIn: 'root' })
export class TemplatesEventProvider extends DomainEventProvider<NotesTemplateEvent> {}
